import styled from 'styled-components/macro';
import { COLORS, easyMoveX, easyMove, Z_INDEX } from 'styleguide';

const Tooltip = styled.div`
  animation: ${({ isSmall }) => (isSmall ? easyMove : easyMoveX)} 0.25s ease-out;
  position: absolute;
  ${({ isSmall }) => (isSmall ? `
    top: 25px;
    left: -100px;
  ` : `
    top: -10px;
    left: 35px;
  `)}
  width: 235px;
  padding: 24px;
  border-radius: 4px;
  background-color: ${COLORS.line};
  z-index: ${Z_INDEX.pop_up};

  &::after {
    content: '';
    position: absolute;
    ${({ isSmall }) => (isSmall ? `
      top: -13px;
      left: 102px;
      border: 5px solid transparent;
      border-bottom: 8px solid ${COLORS.line};
    ` : `
      top: 15px;
      left: -12px;
      border: 5px solid transparent;
      border-right: 8px solid ${COLORS.line};
    `)}
  }
`;

export default Tooltip;
